/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * RumbleDirect API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DossierDossierAssignResourceDossierAssignInputJson,
  DossierDossierAssignResourceDossierAssignUserCollectionInputJson,
  DossierDossierAssignResourceDossierDetailOutputJsonld,
  DossierDossierConceptResourceConceptInputJson,
  DossierDossierConceptResourceConceptInputMergePatchJson,
  DossierDossierConceptResourceConceptInviteInputJson,
  DossierDossierConceptResourceConceptOutputJsonld,
  DossierDossierExportResourceDossierExportRequestOutputJsonld,
  DossierDossierExportResourceJson,
  DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson,
  DossierDossierRepairDecisionResourceDossierRepairDecisionOutputJsonld,
  DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson,
  DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson,
  DossierDossierResourceDossierDetailOutputJsonld,
  DossierDossierResourceDossierMediaLinkInputJson,
  DossierDossierResourceDossierMediaOutputJsonld,
  DossierDossierResourceDossierStatsOutputJsonld,
  DossierDossierWorkflowResourceTransitionCollectionJsonld,
  DossierDossierWorkflowResourceWorkflowStateCollectionJsonld,
  DossierDossierWorkflowResourceWorkflowTransitionJson,
  DossierDossierWorkflowResourceWorkflowTransitionedJsonld,
  DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson,
  DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierOutJsonld,
  ErrorJsonJsonproblem,
  ErrorJsonldJsonld,
  GetAdminDossierStatusesBrief200,
  GetAdminDossiers200,
  GetAdminDossiersBrief200,
  GetAdminDossiersBriefParams,
  GetAdminDossiersDossierIdMedia200,
  GetAdminDossiersDossierIdParams,
  GetAdminDossiersDossierIdServicePartnerSelector200,
  GetAdminDossiersDossierIdServicePartnerSelectorParams,
  GetAdminDossiersParams,
  GetAdminDossiersStatsByStatus200,
  GetDossiersCauseOfDamage200,
  GetDossiersDamageFromDirection200,
  GetDossiersGlassDamageLocation200,
  GetDossiersIdWorkflowTransitionsParams,
  GetDossiersOtherParty200,
  GetDossiersTypeOfDamage200,
  PostAdminDossiersExportParams,
  ValidationExceptionJsonJson,
  ValidationExceptionJsonldJsonld
} from '../model';

import { customInstance } from '../../mutator';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Returns the collection of dossiers for the given affiliate.
 */
export const getAdminDossiers = (
    params?: GetAdminDossiersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAdminDossiers200>(
      {url: `/admin/dossiers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminDossiersQueryKey = (params?: GetAdminDossiersParams,) => {
    return [
    `/admin/dossiers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminDossiersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params?: GetAdminDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiers>>> = ({ signal }) => getAdminDossiers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiers>>>
export type GetAdminDossiersQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiers<TData = Awaited<ReturnType<typeof getAdminDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: undefined |  GetAdminDossiersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiers>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiers<TData = Awaited<ReturnType<typeof getAdminDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params?: GetAdminDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiers>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiers<TData = Awaited<ReturnType<typeof getAdminDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params?: GetAdminDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the collection of dossiers for the given affiliate.
 */

export function useGetAdminDossiers<TData = Awaited<ReturnType<typeof getAdminDossiers>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params?: GetAdminDossiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Id, vehicle, status, driver, created date and damage date only: the same list filters as the full collection, without its join graph. Backs the topbar quick-jump search.
 * @summary Returns the brief collection of dossiers for the given affiliate.
 */
export const getAdminDossiersBrief = (
    params?: GetAdminDossiersBriefParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAdminDossiersBrief200>(
      {url: `/admin/dossiers/brief`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminDossiersBriefQueryKey = (params?: GetAdminDossiersBriefParams,) => {
    return [
    `/admin/dossiers/brief`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminDossiersBriefQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(params?: GetAdminDossiersBriefParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersBriefQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersBrief>>> = ({ signal }) => getAdminDossiersBrief(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersBriefQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersBrief>>>
export type GetAdminDossiersBriefQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersBrief<TData = Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params: undefined |  GetAdminDossiersBriefParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersBrief>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersBrief>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersBrief<TData = Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params?: GetAdminDossiersBriefParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersBrief>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersBrief>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersBrief<TData = Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params?: GetAdminDossiersBriefParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the brief collection of dossiers for the given affiliate.
 */

export function useGetAdminDossiersBrief<TData = Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 params?: GetAdminDossiersBriefParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersBrief>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersBriefQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Accepts the same filters as GET /admin/dossiers and queues an export of all matching dossiers, ignoring pagination. Returns immediately: the file is built by a worker and uploaded to the imports storage, and the returned job id identifies that work. Only dossiers of the RepairDirect type are exported, since the exported columns only exist there.
 * @summary Queue an Excel export of every dossier matching the given list filters
 */
export const postAdminDossiersExport = (
    dossierDossierExportResourceJson: DossierDossierExportResourceJson,
    params?: PostAdminDossiersExportParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierExportResourceDossierExportRequestOutputJsonld>(
      {url: `/admin/dossiers/export`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierExportResourceJson,
        params, signal
    },
      options);
    }




export const getPostAdminDossiersExportMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersExport>>, TError,{data: DossierDossierExportResourceJson;params?: PostAdminDossiersExportParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersExport>>, TError,{data: DossierDossierExportResourceJson;params?: PostAdminDossiersExportParams}, TContext> => {

const mutationKey = ['postAdminDossiersExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersExport>>, {data: DossierDossierExportResourceJson;params?: PostAdminDossiersExportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAdminDossiersExport(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersExportMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersExport>>>
    export type PostAdminDossiersExportMutationBody = DossierDossierExportResourceJson
    export type PostAdminDossiersExportMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Queue an Excel export of every dossier matching the given list filters
 */
export const usePostAdminDossiersExport = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersExport>>, TError,{data: DossierDossierExportResourceJson;params?: PostAdminDossiersExportParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersExport>>,
        TError,
        {data: DossierDossierExportResourceJson;params?: PostAdminDossiersExportParams},
        TContext
      > => {
      return useMutation(getPostAdminDossiersExportMutationOptions(options), queryClient);
    }
    /**
 * Retrieves a DossierResource resource.
 * @summary Retrieves a DossierResource resource.
 */
export const getAdminDossiersDossierId = (
    dossierId: string,
    params?: GetAdminDossiersDossierIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierResourceDossierDetailOutputJsonld>(
      {url: `/admin/dossiers/${dossierId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminDossiersDossierIdQueryKey = (dossierId: string,
    params?: GetAdminDossiersDossierIdParams,) => {
    return [
    `/admin/dossiers/${dossierId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminDossiersDossierIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(dossierId: string,
    params?: GetAdminDossiersDossierIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersDossierIdQueryKey(dossierId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersDossierId>>> = ({ signal }) => getAdminDossiersDossierId(dossierId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dossierId !== null && dossierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersDossierIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersDossierId>>>
export type GetAdminDossiersDossierIdQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersDossierId<TData = Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string,
    params: undefined |  GetAdminDossiersDossierIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierId>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierId<TData = Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string,
    params?: GetAdminDossiersDossierIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierId>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierId<TData = Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string,
    params?: GetAdminDossiersDossierIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a DossierResource resource.
 */

export function useGetAdminDossiersDossierId<TData = Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string,
    params?: GetAdminDossiersDossierIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersDossierIdQueryOptions(dossierId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Sets the assignee of the given dossier to the provided user, or clears it when `assignee` is null.
 * @summary Assign or unassign a dossier to an admin user
 */
export const postAdminDossiersDossierIdAssign = (
    dossierId: string,
    dossierDossierAssignResourceDossierAssignInputJson: DossierDossierAssignResourceDossierAssignInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierAssignResourceDossierDetailOutputJsonld>(
      {url: `/admin/dossiers/${dossierId}/assign`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierAssignResourceDossierAssignInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdAssignMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssign>>, TError,{dossierId: string;data: DossierDossierAssignResourceDossierAssignInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssign>>, TError,{dossierId: string;data: DossierDossierAssignResourceDossierAssignInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdAssign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssign>>, {dossierId: string;data: DossierDossierAssignResourceDossierAssignInputJson}> = (props) => {
          const {dossierId,data} = props ?? {};

          return  postAdminDossiersDossierIdAssign(dossierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssign>>>
    export type PostAdminDossiersDossierIdAssignMutationBody = DossierDossierAssignResourceDossierAssignInputJson
    export type PostAdminDossiersDossierIdAssignMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Assign or unassign a dossier to an admin user
 */
export const usePostAdminDossiersDossierIdAssign = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssign>>, TError,{dossierId: string;data: DossierDossierAssignResourceDossierAssignInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdAssign>>,
        TError,
        {dossierId: string;data: DossierDossierAssignResourceDossierAssignInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdAssignMutationOptions(options), queryClient);
    }
    /**
 * Sets the team of the given dossier, or clears it when `userCollection` is null. The assignee is left unchanged.
 * @summary Assign or unassign a dossier to a team
 */
export const postAdminDossiersDossierIdAssignUserCollection = (
    dossierId: string,
    dossierDossierAssignResourceDossierAssignUserCollectionInputJson: DossierDossierAssignResourceDossierAssignUserCollectionInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierAssignResourceDossierDetailOutputJsonld>(
      {url: `/admin/dossiers/${dossierId}/assign-user-collection`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierAssignResourceDossierAssignUserCollectionInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdAssignUserCollectionMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignUserCollection>>, TError,{dossierId: string;data: DossierDossierAssignResourceDossierAssignUserCollectionInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignUserCollection>>, TError,{dossierId: string;data: DossierDossierAssignResourceDossierAssignUserCollectionInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdAssignUserCollection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignUserCollection>>, {dossierId: string;data: DossierDossierAssignResourceDossierAssignUserCollectionInputJson}> = (props) => {
          const {dossierId,data} = props ?? {};

          return  postAdminDossiersDossierIdAssignUserCollection(dossierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdAssignUserCollectionMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignUserCollection>>>
    export type PostAdminDossiersDossierIdAssignUserCollectionMutationBody = DossierDossierAssignResourceDossierAssignUserCollectionInputJson
    export type PostAdminDossiersDossierIdAssignUserCollectionMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Assign or unassign a dossier to a team
 */
export const usePostAdminDossiersDossierIdAssignUserCollection = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignUserCollection>>, TError,{dossierId: string;data: DossierDossierAssignResourceDossierAssignUserCollectionInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignUserCollection>>,
        TError,
        {dossierId: string;data: DossierDossierAssignResourceDossierAssignUserCollectionInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdAssignUserCollectionMutationOptions(options), queryClient);
    }
    /**
 * Returns an empty collection when no selector query is configured for the dossier's type. Every input is derived from the dossier itself, except the reference address, which can optionally be overridden via postalCode/streetNumber/streetNumberAddition to search from a different location than the dossier's own driver address.
 * @summary Run the service partner selector query configured for this dossier's type
 */
export const getAdminDossiersDossierIdServicePartnerSelector = (
    dossierId: string,
    params?: GetAdminDossiersDossierIdServicePartnerSelectorParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAdminDossiersDossierIdServicePartnerSelector200>(
      {url: `/admin/dossiers/${dossierId}/service-partner-selector`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAdminDossiersDossierIdServicePartnerSelectorQueryKey = (dossierId: string,
    params?: GetAdminDossiersDossierIdServicePartnerSelectorParams,) => {
    return [
    `/admin/dossiers/${dossierId}/service-partner-selector`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminDossiersDossierIdServicePartnerSelectorQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | void>(dossierId: string,
    params?: GetAdminDossiersDossierIdServicePartnerSelectorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersDossierIdServicePartnerSelectorQueryKey(dossierId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>> = ({ signal }) => getAdminDossiersDossierIdServicePartnerSelector(dossierId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dossierId !== null && dossierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersDossierIdServicePartnerSelectorQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>>
export type GetAdminDossiersDossierIdServicePartnerSelectorQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem | void


export function useGetAdminDossiersDossierIdServicePartnerSelector<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | void>(
 dossierId: string,
    params: undefined |  GetAdminDossiersDossierIdServicePartnerSelectorParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierIdServicePartnerSelector<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | void>(
 dossierId: string,
    params?: GetAdminDossiersDossierIdServicePartnerSelectorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierIdServicePartnerSelector<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | void>(
 dossierId: string,
    params?: GetAdminDossiersDossierIdServicePartnerSelectorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run the service partner selector query configured for this dossier's type
 */

export function useGetAdminDossiersDossierIdServicePartnerSelector<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | void>(
 dossierId: string,
    params?: GetAdminDossiersDossierIdServicePartnerSelectorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdServicePartnerSelector>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersDossierIdServicePartnerSelectorQueryOptions(dossierId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Sets (or replaces) the dossier's service partner without sending the email-to-service-partner notification, so it can be used on a dossier that has no attachable photos yet. Reuses the pre-switch/switch rule triggers from the Repair Direct Generic patch flow.
 * @summary Assign a service partner to a dossier ("Hersteller toewijzen")
 */
export const postAdminDossiersDossierIdAssignServicePartnerServicePartnerId = (
    dossierId: string,
    servicePartnerId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/assign-service-partner/${servicePartnerId}`, method: 'POST', signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdAssignServicePartnerServicePartnerIdMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignServicePartnerServicePartnerId>>, TError,{dossierId: string;servicePartnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignServicePartnerServicePartnerId>>, TError,{dossierId: string;servicePartnerId: string}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdAssignServicePartnerServicePartnerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignServicePartnerServicePartnerId>>, {dossierId: string;servicePartnerId: string}> = (props) => {
          const {dossierId,servicePartnerId} = props ?? {};

          return  postAdminDossiersDossierIdAssignServicePartnerServicePartnerId(dossierId,servicePartnerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdAssignServicePartnerServicePartnerIdMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignServicePartnerServicePartnerId>>>

    export type PostAdminDossiersDossierIdAssignServicePartnerServicePartnerIdMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Assign a service partner to a dossier ("Hersteller toewijzen")
 */
export const usePostAdminDossiersDossierIdAssignServicePartnerServicePartnerId = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignServicePartnerServicePartnerId>>, TError,{dossierId: string;servicePartnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdAssignServicePartnerServicePartnerId>>,
        TError,
        {dossierId: string;servicePartnerId: string},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdAssignServicePartnerServicePartnerIdMutationOptions(options), queryClient);
    }
    /**
 * Triggers the admin email-to-service-partner flow for a dossier. The dispatched rule trigger resolves the configured email template and attaches photo media according to the RuleAction configuration.
 * @summary Send dossier details email to a chosen service partner
 */
export const postAdminDossiersDossierIdSendToServicePartnerServicePartnerId = (
    dossierId: string,
    servicePartnerId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/send-to-service-partner/${servicePartnerId}`, method: 'POST', signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdSendToServicePartnerServicePartnerIdMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdSendToServicePartnerServicePartnerId>>, TError,{dossierId: string;servicePartnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdSendToServicePartnerServicePartnerId>>, TError,{dossierId: string;servicePartnerId: string}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdSendToServicePartnerServicePartnerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdSendToServicePartnerServicePartnerId>>, {dossierId: string;servicePartnerId: string}> = (props) => {
          const {dossierId,servicePartnerId} = props ?? {};

          return  postAdminDossiersDossierIdSendToServicePartnerServicePartnerId(dossierId,servicePartnerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdSendToServicePartnerServicePartnerIdMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdSendToServicePartnerServicePartnerId>>>

    export type PostAdminDossiersDossierIdSendToServicePartnerServicePartnerIdMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Send dossier details email to a chosen service partner
 */
export const usePostAdminDossiersDossierIdSendToServicePartnerServicePartnerId = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdSendToServicePartnerServicePartnerId>>, TError,{dossierId: string;servicePartnerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdSendToServicePartnerServicePartnerId>>,
        TError,
        {dossierId: string;servicePartnerId: string},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdSendToServicePartnerServicePartnerIdMutationOptions(options), queryClient);
    }
    /**
 * Returns the status labels each branch leads to, whether the admin picks the repairer, and the side effects (email, ESA-20, sync, DW Pro) each branch triggers according to the active rules. The side effects are a best-effort preview: rule conditions are evaluated against the dossier as it is now. Answers 404 when the dossier cannot make a repair decision in its current workflow state.
 * @summary Describe the "Herstelkeuze" (repair decision) available to a dossier
 */
export const getAdminDossiersDossierIdRepairDecision = (
    dossierId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierRepairDecisionResourceDossierRepairDecisionOutputJsonld>(
      {url: `/admin/dossiers/${dossierId}/repair-decision`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminDossiersDossierIdRepairDecisionQueryKey = (dossierId: string,) => {
    return [
    `/admin/dossiers/${dossierId}/repair-decision`
    ] as const;
    }


export const getGetAdminDossiersDossierIdRepairDecisionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersDossierIdRepairDecisionQueryKey(dossierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>> = ({ signal }) => getAdminDossiersDossierIdRepairDecision(dossierId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dossierId !== null && dossierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersDossierIdRepairDecisionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>>
export type GetAdminDossiersDossierIdRepairDecisionQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersDossierIdRepairDecision<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierIdRepairDecision<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierIdRepairDecision<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Describe the "Herstelkeuze" (repair decision) available to a dossier
 */

export function useGetAdminDossiersDossierIdRepairDecision<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdRepairDecision>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersDossierIdRepairDecisionQueryOptions(dossierId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Sets repairRequested, optionally assigns the repairer, assigns the current user when the dossier has no assignee yet, optionally records the reason as a dossier note (mandatory when repairRequested is false), and moves the dossier through the workflow transitions the repair decision resolves to - all inside one database transaction, so the decision can never be left half-applied. Answers 422 when the dossier cannot make a repair decision in its current state. Gated on admin_dossier_update, the same permission the generic workflow transition endpoint uses, since this also drives a transition and creates a note.
 * @summary Record the "Herstelkeuze" (repair decision) for a dossier
 */
export const postAdminDossiersDossierIdRepairDecision = (
    dossierId: string,
    dossierDossierRepairDecisionResourceDossierRepairDecisionInputJson: DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/repair-decision`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierRepairDecisionResourceDossierRepairDecisionInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdRepairDecisionMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairDecision>>, TError,{dossierId: string;data: DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairDecision>>, TError,{dossierId: string;data: DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdRepairDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairDecision>>, {dossierId: string;data: DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson}> = (props) => {
          const {dossierId,data} = props ?? {};

          return  postAdminDossiersDossierIdRepairDecision(dossierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdRepairDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairDecision>>>
    export type PostAdminDossiersDossierIdRepairDecisionMutationBody = DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson
    export type PostAdminDossiersDossierIdRepairDecisionMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Record the "Herstelkeuze" (repair decision) for a dossier
 */
export const usePostAdminDossiersDossierIdRepairDecision = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairDecision>>, TError,{dossierId: string;data: DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairDecision>>,
        TError,
        {dossierId: string;data: DossierDossierRepairDecisionResourceDossierRepairDecisionInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdRepairDecisionMutationOptions(options), queryClient);
    }
    /**
 * Creates a DossierRepairPlanningResource resource.
 * @summary Creates a DossierRepairPlanningResource resource.
 */
export const postAdminDossiersDossierIdRepairPlanning = (
    dossierId: string,
    dossierDossierRepairPlanningResourceDossierRepairPlanningInputJson: DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/repair-planning`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierRepairPlanningResourceDossierRepairPlanningInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdRepairPlanningMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanning>>, TError,{dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanning>>, TError,{dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdRepairPlanning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanning>>, {dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson}> = (props) => {
          const {dossierId,data} = props ?? {};

          return  postAdminDossiersDossierIdRepairPlanning(dossierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdRepairPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanning>>>
    export type PostAdminDossiersDossierIdRepairPlanningMutationBody = DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson
    export type PostAdminDossiersDossierIdRepairPlanningMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Creates a DossierRepairPlanningResource resource.
 */
export const usePostAdminDossiersDossierIdRepairPlanning = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanning>>, TError,{dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanning>>,
        TError,
        {dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdRepairPlanningMutationOptions(options), queryClient);
    }
    /**
 * Creates a DossierRepairPlanningResource resource.
 * @summary Creates a DossierRepairPlanningResource resource.
 */
export const postAdminDossiersDossierIdRepairPlanningDelay = (
    dossierId: string,
    dossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson: DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/repair-planning-delay`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdRepairPlanningDelayMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanningDelay>>, TError,{dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanningDelay>>, TError,{dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdRepairPlanningDelay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanningDelay>>, {dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson}> = (props) => {
          const {dossierId,data} = props ?? {};

          return  postAdminDossiersDossierIdRepairPlanningDelay(dossierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdRepairPlanningDelayMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanningDelay>>>
    export type PostAdminDossiersDossierIdRepairPlanningDelayMutationBody = DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson
    export type PostAdminDossiersDossierIdRepairPlanningDelayMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Creates a DossierRepairPlanningResource resource.
 */
export const usePostAdminDossiersDossierIdRepairPlanningDelay = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanningDelay>>, TError,{dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdRepairPlanningDelay>>,
        TError,
        {dossierId: string;data: DossierDossierRepairPlanningResourceDossierRepairPlanningDelayInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdRepairPlanningDelayMutationOptions(options), queryClient);
    }
    /**
 * Archives a specific dossier by its ID.
 * @summary Archive a dossier by ID
 */
export const postAdminDossiersDossierIdArchive = (
    dossierId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/archive`, method: 'POST', signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdArchiveMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdArchive>>, TError,{dossierId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdArchive>>, TError,{dossierId: string}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdArchive>>, {dossierId: string}> = (props) => {
          const {dossierId} = props ?? {};

          return  postAdminDossiersDossierIdArchive(dossierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdArchive>>>

    export type PostAdminDossiersDossierIdArchiveMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Archive a dossier by ID
 */
export const usePostAdminDossiersDossierIdArchive = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdArchive>>, TError,{dossierId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdArchive>>,
        TError,
        {dossierId: string},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdArchiveMutationOptions(options), queryClient);
    }
    /**
 * Unarchives a specific dossier by its ID.
 * @summary Unarchive a dossier by ID
 */
export const postAdminDossiersDossierIdUnarchive = (
    dossierId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/admin/dossiers/${dossierId}/unarchive`, method: 'POST', signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdUnarchiveMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdUnarchive>>, TError,{dossierId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdUnarchive>>, TError,{dossierId: string}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdUnarchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdUnarchive>>, {dossierId: string}> = (props) => {
          const {dossierId} = props ?? {};

          return  postAdminDossiersDossierIdUnarchive(dossierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdUnarchiveMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdUnarchive>>>

    export type PostAdminDossiersDossierIdUnarchiveMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Unarchive a dossier by ID
 */
export const usePostAdminDossiersDossierIdUnarchive = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdUnarchive>>, TError,{dossierId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdUnarchive>>,
        TError,
        {dossierId: string},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdUnarchiveMutationOptions(options), queryClient);
    }
    /**
 * Merges the dossier's own media usages with the media captured through its Solera ImageCapture sents, de-duplicated by media id (the dossier-owned usage wins, as it carries the more specific intent). Returned unfiltered by intent and mime type: the consumer partitions them into damage photos and documents.
 * @summary Returns all media attached to the given dossier.
 */
export const getAdminDossiersDossierIdMedia = (
    dossierId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAdminDossiersDossierIdMedia200>(
      {url: `/admin/dossiers/${dossierId}/media`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminDossiersDossierIdMediaQueryKey = (dossierId: string,) => {
    return [
    `/admin/dossiers/${dossierId}/media`
    ] as const;
    }


export const getGetAdminDossiersDossierIdMediaQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersDossierIdMediaQueryKey(dossierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>> = ({ signal }) => getAdminDossiersDossierIdMedia(dossierId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dossierId !== null && dossierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersDossierIdMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>>
export type GetAdminDossiersDossierIdMediaQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersDossierIdMedia<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierIdMedia<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersDossierIdMedia<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns all media attached to the given dossier.
 */

export function useGetAdminDossiersDossierIdMedia<TData = Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersDossierIdMedia>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersDossierIdMediaQueryOptions(dossierId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Links an existing media -- uploaded first through POST /affiliates/{affiliateId}/media, which owns the multipart handling -- to the dossier under the given intent. The intent is validated against the damage-photo and dossier-document intents, so the affiliate branding intents and the inbound-correspondence `media` catch-all cannot be set by hand. Returns the created attachment in the same shape as the media collection.
 * @summary Attach an already-uploaded media to the dossier.
 */
export const postAdminDossiersDossierIdMedia = (
    dossierId: string,
    dossierDossierResourceDossierMediaLinkInputJson: DossierDossierResourceDossierMediaLinkInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierResourceDossierMediaOutputJsonld>(
      {url: `/admin/dossiers/${dossierId}/media`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierResourceDossierMediaLinkInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdMediaMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdMedia>>, TError,{dossierId: string;data: DossierDossierResourceDossierMediaLinkInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdMedia>>, TError,{dossierId: string;data: DossierDossierResourceDossierMediaLinkInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdMedia>>, {dossierId: string;data: DossierDossierResourceDossierMediaLinkInputJson}> = (props) => {
          const {dossierId,data} = props ?? {};

          return  postAdminDossiersDossierIdMedia(dossierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdMediaMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdMedia>>>
    export type PostAdminDossiersDossierIdMediaMutationBody = DossierDossierResourceDossierMediaLinkInputJson
    export type PostAdminDossiersDossierIdMediaMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Attach an already-uploaded media to the dossier.
 */
export const usePostAdminDossiersDossierIdMedia = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdMedia>>, TError,{dossierId: string;data: DossierDossierResourceDossierMediaLinkInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdMedia>>,
        TError,
        {dossierId: string;data: DossierDossierResourceDossierMediaLinkInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdMediaMutationOptions(options), queryClient);
    }
    /**
 * Renders the document template configured in the affiliate setting `damage_intake_report_document_template` -- damage data, vehicle data and damage photos -- to a PDF and attaches it to the dossier under the `damage_intake_report` intent. Every call adds a new document; earlier reports are kept. Returns the created attachment in the same shape as the media collection. Responds 422 when the affiliate has no (renderable) template configured.
 * @summary Generate the damage intake report PDF of the dossier.
 */
export const postAdminDossiersDossierIdDamageIntakeReport = (
    dossierId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierResourceDossierMediaOutputJsonld>(
      {url: `/admin/dossiers/${dossierId}/damage-intake-report`, method: 'POST', signal
    },
      options);
    }




export const getPostAdminDossiersDossierIdDamageIntakeReportMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdDamageIntakeReport>>, TError,{dossierId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdDamageIntakeReport>>, TError,{dossierId: string}, TContext> => {

const mutationKey = ['postAdminDossiersDossierIdDamageIntakeReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersDossierIdDamageIntakeReport>>, {dossierId: string}> = (props) => {
          const {dossierId} = props ?? {};

          return  postAdminDossiersDossierIdDamageIntakeReport(dossierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersDossierIdDamageIntakeReportMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersDossierIdDamageIntakeReport>>>

    export type PostAdminDossiersDossierIdDamageIntakeReportMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Generate the damage intake report PDF of the dossier.
 */
export const usePostAdminDossiersDossierIdDamageIntakeReport = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersDossierIdDamageIntakeReport>>, TError,{dossierId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersDossierIdDamageIntakeReport>>,
        TError,
        {dossierId: string},
        TContext
      > => {
      return useMutation(getPostAdminDossiersDossierIdDamageIntakeReportMutationOptions(options), queryClient);
    }
    /**
 * Count-only KPI figures (total active, unread, assigned to the current admin) used by the dashboard, without paginating/serializing full dossier rows.
 * @summary Returns lightweight dossier counts for the given affiliate.
 */
export const getAdminDossiersStats = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierResourceDossierStatsOutputJsonld>(
      {url: `/admin/dossiers/stats`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminDossiersStatsQueryKey = () => {
    return [
    `/admin/dossiers/stats`
    ] as const;
    }


export const getGetAdminDossiersStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersStats>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersStats>>> = ({ signal }) => getAdminDossiersStats(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersStats>>>
export type GetAdminDossiersStatsQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersStats<TData = Awaited<ReturnType<typeof getAdminDossiersStats>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersStats<TData = Awaited<ReturnType<typeof getAdminDossiersStats>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersStats<TData = Awaited<ReturnType<typeof getAdminDossiersStats>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns lightweight dossier counts for the given affiliate.
 */

export function useGetAdminDossiersStats<TData = Awaited<ReturnType<typeof getAdminDossiersStats>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Count-only status distribution (one entry per status that has at least one active dossier) used by the dashboard's status-distribution chart, without paginating/serializing full dossier rows.
 * @summary Returns the count of active dossiers per status for the given affiliate.
 */
export const getAdminDossiersStatsByStatus = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAdminDossiersStatsByStatus200>(
      {url: `/admin/dossiers/stats-by-status`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminDossiersStatsByStatusQueryKey = () => {
    return [
    `/admin/dossiers/stats-by-status`
    ] as const;
    }


export const getGetAdminDossiersStatsByStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersStatsByStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>> = ({ signal }) => getAdminDossiersStatsByStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersStatsByStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>>
export type GetAdminDossiersStatsByStatusQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersStatsByStatus<TData = Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersStatsByStatus<TData = Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersStatsByStatus<TData = Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the count of active dossiers per status for the given affiliate.
 */

export function useGetAdminDossiersStatsByStatus<TData = Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersStatsByStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersStatsByStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a repair-direct generic dossier as an admin actor
 */
export const postAdminDossiersRepairDirectGeneric = (
    dossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson: NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierOutJsonld>(
      {url: `/admin/dossiers/repair-direct/generic`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson, signal
    },
      options);
    }




export const getPostAdminDossiersRepairDirectGenericMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersRepairDirectGeneric>>, TError,{data: NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersRepairDirectGeneric>>, TError,{data: NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>}, TContext> => {

const mutationKey = ['postAdminDossiersRepairDirectGeneric'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersRepairDirectGeneric>>, {data: NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>}> = (props) => {
          const {data} = props ?? {};

          return  postAdminDossiersRepairDirectGeneric(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersRepairDirectGenericMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersRepairDirectGeneric>>>
    export type PostAdminDossiersRepairDirectGenericMutationBody = NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>
    export type PostAdminDossiersRepairDirectGenericMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Create a repair-direct generic dossier as an admin actor
 */
export const usePostAdminDossiersRepairDirectGeneric = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersRepairDirectGeneric>>, TError,{data: NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersRepairDirectGeneric>>,
        TError,
        {data: NonReadonly<DossierRepairDirectGenericDossierResourceRepairDirectGenericDossierInJson>},
        TContext
      > => {
      return useMutation(getPostAdminDossiersRepairDirectGenericMutationOptions(options), queryClient);
    }
    /**
 * @summary Concept dossier
 */
export const postAdminDossiersConceptInvite = (
    dossierDossierConceptResourceConceptInviteInputJson: NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierConceptResourceConceptOutputJsonld>(
      {url: `/admin/dossiers/concept-invite`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierConceptResourceConceptInviteInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersConceptInviteMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersConceptInvite>>, TError,{data: NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersConceptInvite>>, TError,{data: NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>}, TContext> => {

const mutationKey = ['postAdminDossiersConceptInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersConceptInvite>>, {data: NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>}> = (props) => {
          const {data} = props ?? {};

          return  postAdminDossiersConceptInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersConceptInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersConceptInvite>>>
    export type PostAdminDossiersConceptInviteMutationBody = NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>
    export type PostAdminDossiersConceptInviteMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Concept dossier
 */
export const usePostAdminDossiersConceptInvite = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersConceptInvite>>, TError,{data: NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersConceptInvite>>,
        TError,
        {data: NonReadonly<DossierDossierConceptResourceConceptInviteInputJson>},
        TContext
      > => {
      return useMutation(getPostAdminDossiersConceptInviteMutationOptions(options), queryClient);
    }
    /**
 * @summary Concept dossier
 */
export const postAdminDossiersConcept = (
    dossierDossierConceptResourceConceptInputJson: DossierDossierConceptResourceConceptInputJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierConceptResourceConceptOutputJsonld>(
      {url: `/admin/dossiers/concept`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierConceptResourceConceptInputJson, signal
    },
      options);
    }




export const getPostAdminDossiersConceptMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersConcept>>, TError,{data: DossierDossierConceptResourceConceptInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersConcept>>, TError,{data: DossierDossierConceptResourceConceptInputJson}, TContext> => {

const mutationKey = ['postAdminDossiersConcept'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDossiersConcept>>, {data: DossierDossierConceptResourceConceptInputJson}> = (props) => {
          const {data} = props ?? {};

          return  postAdminDossiersConcept(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminDossiersConceptMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDossiersConcept>>>
    export type PostAdminDossiersConceptMutationBody = DossierDossierConceptResourceConceptInputJson
    export type PostAdminDossiersConceptMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Concept dossier
 */
export const usePostAdminDossiersConcept = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDossiersConcept>>, TError,{data: DossierDossierConceptResourceConceptInputJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminDossiersConcept>>,
        TError,
        {data: DossierDossierConceptResourceConceptInputJson},
        TContext
      > => {
      return useMutation(getPostAdminDossiersConceptMutationOptions(options), queryClient);
    }
    /**
 * @summary Concept dossier
 */
export const getAdminDossiersConceptConceptId = (
    conceptId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierConceptResourceConceptOutputJsonld>(
      {url: `/admin/dossiers/concept/${conceptId}`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminDossiersConceptConceptIdQueryKey = (conceptId: string,) => {
    return [
    `/admin/dossiers/concept/${conceptId}`
    ] as const;
    }


export const getGetAdminDossiersConceptConceptIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(conceptId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossiersConceptConceptIdQueryKey(conceptId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>> = ({ signal }) => getAdminDossiersConceptConceptId(conceptId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: conceptId !== null && conceptId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossiersConceptConceptIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>>
export type GetAdminDossiersConceptConceptIdQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossiersConceptConceptId<TData = Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 conceptId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersConceptConceptId<TData = Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 conceptId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossiersConceptConceptId<TData = Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 conceptId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Concept dossier
 */

export function useGetAdminDossiersConceptConceptId<TData = Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 conceptId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossiersConceptConceptId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossiersConceptConceptIdQueryOptions(conceptId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Concept dossier
 */
export const patchAdminDossiersConceptConceptId = (
    conceptId: string,
    dossierDossierConceptResourceConceptInputMergePatchJson: DossierDossierConceptResourceConceptInputMergePatchJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierConceptResourceConceptOutputJsonld>(
      {url: `/admin/dossiers/concept/${conceptId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/merge-patch+json', },
      data: dossierDossierConceptResourceConceptInputMergePatchJson, signal
    },
      options);
    }




export const getPatchAdminDossiersConceptConceptIdMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminDossiersConceptConceptId>>, TError,{conceptId: string;data: DossierDossierConceptResourceConceptInputMergePatchJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminDossiersConceptConceptId>>, TError,{conceptId: string;data: DossierDossierConceptResourceConceptInputMergePatchJson}, TContext> => {

const mutationKey = ['patchAdminDossiersConceptConceptId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminDossiersConceptConceptId>>, {conceptId: string;data: DossierDossierConceptResourceConceptInputMergePatchJson}> = (props) => {
          const {conceptId,data} = props ?? {};

          return  patchAdminDossiersConceptConceptId(conceptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminDossiersConceptConceptIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminDossiersConceptConceptId>>>
    export type PatchAdminDossiersConceptConceptIdMutationBody = DossierDossierConceptResourceConceptInputMergePatchJson
    export type PatchAdminDossiersConceptConceptIdMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Concept dossier
 */
export const usePatchAdminDossiersConceptConceptId = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminDossiersConceptConceptId>>, TError,{conceptId: string;data: DossierDossierConceptResourceConceptInputMergePatchJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminDossiersConceptConceptId>>,
        TError,
        {conceptId: string;data: DossierDossierConceptResourceConceptInputMergePatchJson},
        TContext
      > => {
      return useMutation(getPatchAdminDossiersConceptConceptIdMutationOptions(options), queryClient);
    }
    /**
 * Returns a non-paginated list of the statuses a dossier can be in, for the current affiliate, one group per concrete dossier subtype (dossierType) that has an active workflow configured, each holding that workflow's states in workflow order. Dossier subtypes without a configured workflow are omitted; affiliates without any dossier workflow configured get an empty list.
 * @summary Get a brief list of dossier statuses, grouped by dossier subtype
 */
export const getAdminDossierStatusesBrief = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAdminDossierStatusesBrief200>(
      {url: `/admin/dossier-statuses/brief`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminDossierStatusesBriefQueryKey = () => {
    return [
    `/admin/dossier-statuses/brief`
    ] as const;
    }


export const getGetAdminDossierStatusesBriefQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDossierStatusesBriefQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>> = ({ signal }) => getAdminDossierStatusesBrief(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminDossierStatusesBriefQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>>
export type GetAdminDossierStatusesBriefQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetAdminDossierStatusesBrief<TData = Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossierStatusesBrief<TData = Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>,
          TError,
          Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminDossierStatusesBrief<TData = Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a brief list of dossier statuses, grouped by dossier subtype
 */

export function useGetAdminDossierStatusesBrief<TData = Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminDossierStatusesBrief>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminDossierStatusesBriefQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns all available workflow transitions for the specified dossier based on its current state.
 * @summary Get available workflow transitions for a dossier
 */
export const getDossiersIdWorkflowTransitions = (
    id: string,
    params?: GetDossiersIdWorkflowTransitionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierWorkflowResourceTransitionCollectionJsonld>(
      {url: `/dossiers/${id}/workflow/transitions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDossiersIdWorkflowTransitionsQueryKey = (id: string,
    params?: GetDossiersIdWorkflowTransitionsParams,) => {
    return [
    `/dossiers/${id}/workflow/transitions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDossiersIdWorkflowTransitionsQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(id: string,
    params?: GetDossiersIdWorkflowTransitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersIdWorkflowTransitionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>> = ({ signal }) => getDossiersIdWorkflowTransitions(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersIdWorkflowTransitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>>
export type GetDossiersIdWorkflowTransitionsQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersIdWorkflowTransitions<TData = Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string,
    params: undefined |  GetDossiersIdWorkflowTransitionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>,
          TError,
          Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersIdWorkflowTransitions<TData = Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string,
    params?: GetDossiersIdWorkflowTransitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>,
          TError,
          Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersIdWorkflowTransitions<TData = Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string,
    params?: GetDossiersIdWorkflowTransitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available workflow transitions for a dossier
 */

export function useGetDossiersIdWorkflowTransitions<TData = Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 id: string,
    params?: GetDossiersIdWorkflowTransitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersIdWorkflowTransitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersIdWorkflowTransitionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Applies the specified workflow transition to the dossier, moving it to a new state.
 * @summary Apply a workflow transition to a dossier
 */
export const postDossiersIdWorkflowTransition = (
    id: string,
    dossierDossierWorkflowResourceWorkflowTransitionJson: DossierDossierWorkflowResourceWorkflowTransitionJson,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierWorkflowResourceWorkflowTransitionedJsonld>(
      {url: `/dossiers/${id}/workflow/transition`, method: 'POST',
      headers: {'Content-Type': 'application/ld+json', },
      data: dossierDossierWorkflowResourceWorkflowTransitionJson, signal
    },
      options);
    }




export const getPostDossiersIdWorkflowTransitionMutationOptions = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDossiersIdWorkflowTransition>>, TError,{id: string;data: DossierDossierWorkflowResourceWorkflowTransitionJson}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postDossiersIdWorkflowTransition>>, TError,{id: string;data: DossierDossierWorkflowResourceWorkflowTransitionJson}, TContext> => {

const mutationKey = ['postDossiersIdWorkflowTransition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDossiersIdWorkflowTransition>>, {id: string;data: DossierDossierWorkflowResourceWorkflowTransitionJson}> = (props) => {
          const {id,data} = props ?? {};

          return  postDossiersIdWorkflowTransition(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostDossiersIdWorkflowTransitionMutationResult = NonNullable<Awaited<ReturnType<typeof postDossiersIdWorkflowTransition>>>
    export type PostDossiersIdWorkflowTransitionMutationBody = DossierDossierWorkflowResourceWorkflowTransitionJson
    export type PostDossiersIdWorkflowTransitionMutationError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson

    /**
 * @summary Apply a workflow transition to a dossier
 */
export const usePostDossiersIdWorkflowTransition = <TError = ErrorJsonldJsonld | ErrorJsonJsonproblem | ValidationExceptionJsonldJsonld | ValidationExceptionJsonJson,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDossiersIdWorkflowTransition>>, TError,{id: string;data: DossierDossierWorkflowResourceWorkflowTransitionJson}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDossiersIdWorkflowTransition>>,
        TError,
        {id: string;data: DossierDossierWorkflowResourceWorkflowTransitionJson},
        TContext
      > => {
      return useMutation(getPostDossiersIdWorkflowTransitionMutationOptions(options), queryClient);
    }
    /**
 * Returns the states on this dossier's own actual path through its active workflow revision, in workflow order, with the dossier's current state marked: states behind it, the current one, and only the states ahead of it that are certain to follow (an undecided branch's sibling outcomes are omitted until one is taken). Unlike the aggregate /admin/dossier-statuses/brief (which lists every status that could apply to the subtype across the whole affiliate), this always resolves the one, unambiguous revision the dossier is actually placed in - the steps this specific dossier will actually pass through.
 * @summary Get the dossier's own workflow, states in order, current one marked
 */
export const getDossiersDossierIdWorkflowStates = (
    dossierId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DossierDossierWorkflowResourceWorkflowStateCollectionJsonld>(
      {url: `/dossiers/${dossierId}/workflow/states`, method: 'GET', signal
    },
      options);
    }




export const getGetDossiersDossierIdWorkflowStatesQueryKey = (dossierId: string,) => {
    return [
    `/dossiers/${dossierId}/workflow/states`
    ] as const;
    }


export const getGetDossiersDossierIdWorkflowStatesQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersDossierIdWorkflowStatesQueryKey(dossierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>> = ({ signal }) => getDossiersDossierIdWorkflowStates(dossierId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dossierId !== null && dossierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersDossierIdWorkflowStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>>
export type GetDossiersDossierIdWorkflowStatesQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersDossierIdWorkflowStates<TData = Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>,
          TError,
          Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersDossierIdWorkflowStates<TData = Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>,
          TError,
          Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersDossierIdWorkflowStates<TData = Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the dossier's own workflow, states in order, current one marked
 */

export function useGetDossiersDossierIdWorkflowStates<TData = Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
 dossierId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDossierIdWorkflowStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersDossierIdWorkflowStatesQueryOptions(dossierId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves the collection of CauseOfDamage resources.
 * @summary Retrieves the collection of CauseOfDamage resources.
 */
export const getDossiersCauseOfDamage = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetDossiersCauseOfDamage200>(
      {url: `/dossiers/cause-of-damage`, method: 'GET', signal
    },
      options);
    }




export const getGetDossiersCauseOfDamageQueryKey = () => {
    return [
    `/dossiers/cause-of-damage`
    ] as const;
    }


export const getGetDossiersCauseOfDamageQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersCauseOfDamageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>> = ({ signal }) => getDossiersCauseOfDamage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersCauseOfDamageQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>>
export type GetDossiersCauseOfDamageQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersCauseOfDamage<TData = Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersCauseOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDossiersCauseOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersCauseOfDamage<TData = Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersCauseOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDossiersCauseOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersCauseOfDamage<TData = Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of CauseOfDamage resources.
 */

export function useGetDossiersCauseOfDamage<TData = Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersCauseOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersCauseOfDamageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves the collection of OtherParty resources.
 * @summary Retrieves the collection of OtherParty resources.
 */
export const getDossiersOtherParty = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetDossiersOtherParty200>(
      {url: `/dossiers/other-party`, method: 'GET', signal
    },
      options);
    }




export const getGetDossiersOtherPartyQueryKey = () => {
    return [
    `/dossiers/other-party`
    ] as const;
    }


export const getGetDossiersOtherPartyQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersOtherParty>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersOtherParty>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersOtherPartyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersOtherParty>>> = ({ signal }) => getDossiersOtherParty(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersOtherParty>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersOtherPartyQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersOtherParty>>>
export type GetDossiersOtherPartyQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersOtherParty<TData = Awaited<ReturnType<typeof getDossiersOtherParty>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersOtherParty>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersOtherParty>>,
          TError,
          Awaited<ReturnType<typeof getDossiersOtherParty>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersOtherParty<TData = Awaited<ReturnType<typeof getDossiersOtherParty>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersOtherParty>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersOtherParty>>,
          TError,
          Awaited<ReturnType<typeof getDossiersOtherParty>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersOtherParty<TData = Awaited<ReturnType<typeof getDossiersOtherParty>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersOtherParty>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of OtherParty resources.
 */

export function useGetDossiersOtherParty<TData = Awaited<ReturnType<typeof getDossiersOtherParty>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersOtherParty>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersOtherPartyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves the collection of DamageFromDirection resources.
 * @summary Retrieves the collection of DamageFromDirection resources.
 */
export const getDossiersDamageFromDirection = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetDossiersDamageFromDirection200>(
      {url: `/dossiers/damage-from-direction`, method: 'GET', signal
    },
      options);
    }




export const getGetDossiersDamageFromDirectionQueryKey = () => {
    return [
    `/dossiers/damage-from-direction`
    ] as const;
    }


export const getGetDossiersDamageFromDirectionQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersDamageFromDirectionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>> = ({ signal }) => getDossiersDamageFromDirection(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersDamageFromDirectionQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>>
export type GetDossiersDamageFromDirectionQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersDamageFromDirection<TData = Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersDamageFromDirection>>,
          TError,
          Awaited<ReturnType<typeof getDossiersDamageFromDirection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersDamageFromDirection<TData = Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersDamageFromDirection>>,
          TError,
          Awaited<ReturnType<typeof getDossiersDamageFromDirection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersDamageFromDirection<TData = Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of DamageFromDirection resources.
 */

export function useGetDossiersDamageFromDirection<TData = Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersDamageFromDirection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersDamageFromDirectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves the collection of TypeOfDamage resources.
 * @summary Retrieves the collection of TypeOfDamage resources.
 */
export const getDossiersTypeOfDamage = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetDossiersTypeOfDamage200>(
      {url: `/dossiers/type-of-damage`, method: 'GET', signal
    },
      options);
    }




export const getGetDossiersTypeOfDamageQueryKey = () => {
    return [
    `/dossiers/type-of-damage`
    ] as const;
    }


export const getGetDossiersTypeOfDamageQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersTypeOfDamageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>> = ({ signal }) => getDossiersTypeOfDamage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersTypeOfDamageQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>>
export type GetDossiersTypeOfDamageQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersTypeOfDamage<TData = Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersTypeOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDossiersTypeOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersTypeOfDamage<TData = Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersTypeOfDamage>>,
          TError,
          Awaited<ReturnType<typeof getDossiersTypeOfDamage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersTypeOfDamage<TData = Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of TypeOfDamage resources.
 */

export function useGetDossiersTypeOfDamage<TData = Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersTypeOfDamage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersTypeOfDamageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves the collection of GlassDamageLocation resources.
 * @summary Retrieves the collection of GlassDamageLocation resources.
 */
export const getDossiersGlassDamageLocation = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetDossiersGlassDamageLocation200>(
      {url: `/dossiers/glass-damage-location`, method: 'GET', signal
    },
      options);
    }




export const getGetDossiersGlassDamageLocationQueryKey = () => {
    return [
    `/dossiers/glass-damage-location`
    ] as const;
    }


export const getGetDossiersGlassDamageLocationQueryOptions = <TData = Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDossiersGlassDamageLocationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>> = ({ signal }) => getDossiersGlassDamageLocation(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDossiersGlassDamageLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>>
export type GetDossiersGlassDamageLocationQueryError = ErrorJsonldJsonld | ErrorJsonJsonproblem


export function useGetDossiersGlassDamageLocation<TData = Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>,
          TError,
          Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersGlassDamageLocation<TData = Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>,
          TError,
          Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDossiersGlassDamageLocation<TData = Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of GlassDamageLocation resources.
 */

export function useGetDossiersGlassDamageLocation<TData = Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError = ErrorJsonldJsonld | ErrorJsonJsonproblem>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDossiersGlassDamageLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDossiersGlassDamageLocationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






